import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { CurvaAbcVendaExcelExportModalComponent } from './excel';
import { CurvaAbcVendaFilter, CurvaAbcVendaFilterComponent, CurvaAbcVendaFilterStorageService, CurvaAbcVendaFilterInitialization } from './filter';
import { CurvaAbcVendaPerspectivaNavComponent } from './perspectiva/nav';
import { isReferenciaNotaFiscal, isReferenciaPedido } from './referencia';
import { CurvaAbcVendaReportModalComponent } from './report/modal';

@Component({
    selector: 'sgt-curva-abc-venda',
    templateUrl: './curva-abc-venda.component.html',
    styleUrls: ['./curva-abc-venda.component.less']
})
export class CurvaAbcVendaComponent implements OnInit {
    @Input() filterStorageKey = 'curvaAbcVendaFilter';
    @Input() idPessoaFilter: number = null;

    filter = new CurvaAbcVendaFilter();
    filterInitialization = new CurvaAbcVendaFilterInitialization();
    filterReferenciaAplicada: number;
    @ViewChild('filterComponent') filterComponent: CurvaAbcVendaFilterComponent;

    @ViewChild('perspectivaNav') perspectivaNav: CurvaAbcVendaPerspectivaNavComponent;
    @ViewChild('reportModal') reportModal: CurvaAbcVendaReportModalComponent;
    @ViewChild('excelExportModal') excelExportModal: CurvaAbcVendaExcelExportModalComponent;

    constructor(private curvaAbcVendaFilterStorageService: CurvaAbcVendaFilterStorageService) { }

    ngOnInit(): void {
        this.initFilter();
    }

    /** Verifica se a referência selecionada no filtro é por pedido */
    isReferenciaPedido(): boolean {
        return isReferenciaPedido(this.filter?.idReferencia);
    }

    /** Verifica se a referência selecionada no filtro é por nota fiscal */
    isReferenciaNotaFiscal(): boolean {
        return isReferenciaNotaFiscal(this.filter?.idReferencia);
    }

    private setStorage() {
        this.curvaAbcVendaFilterStorageService.set(this.filter, this.filterStorageKey);
    }

    /** Seta os filtros padrões */
    private setDefaultFilters(force = false) {
        if (!this.curvaAbcVendaFilterStorageService.hasFilter(this.filterStorageKey) || force) {
            //
        }
    }

    private initFilter() {
        this.filterInitialization.initialization.subscribe(
            isInitialized => {
                if (isInitialized) {
                    this.setDefaultFilters();

                    setTimeout(() => {
                        this.search();
                    }, 0);
                }
            }
        );
    }

    /** Quando o filtro é alterado */
    onFilterChange() {
        if (!this.filterInitialization.isInitialized()) {
            return;
        }
        this.search();
    }

    /** Ao limpar o filtro */
    onFilterCleaned() {
        this.setDefaultFilters(true);
        setTimeout(() => this.search(), 0);
    }

    /** Realiza as consultas da Curva ABC de Vendas */
    search() {
        this.filterComponent?.close();
        this.filterReferenciaAplicada = this.filter?.idReferencia;

        if (this.idPessoaFilter) {
            this.filter.idPessoa = this.idPessoaFilter;
        }

        this.perspectivaNav?.search();
        this.setStorage();
    }

    openReportModal() {
        this.reportModal?.open(this.perspectivaNav?.getPerspectiva(), this.filter, this.perspectivaNav?.getOrderBy(), this.perspectivaNav?.getOrderByDir());
    }

    openExcelExportModal() {
        this.excelExportModal?.open(this.perspectivaNav?.getPerspectiva(), this.filter, this.perspectivaNav?.getOrderBy(), this.perspectivaNav?.getOrderByDir());
    }
}
